/*
 * Tailwind's `sr-only`, with one substitution: `clip: rect(0,0,0,0)` is not in
 * any CSS plane's property inventory, so the taxonomy fails it closed. The
 * modern `clip-path: inset(50%)` is the accepted equivalent and is what every
 * browser this app supports honours.
 */
.root {
  position: absolute;
  width: var(--size-ds-hairline);
  height: var(--size-ds-hairline);
  padding: var(--spacing-ds-0);
  margin: var(--spacing-ds-px-negative);
  overflow: hidden;
  clip-path: var(--clip-path-ds-visually-hidden);
  white-space: nowrap;
  border-width: var(--border-ds-width-none);
}

/* Skip-link behaviour: reveal the content once focus lands inside it. */
.focusable:focus-within {
  position: static;
  width: var(--width-ds-auto);
  height: var(--height-ds-auto);
  margin: var(--spacing-ds-0);
  overflow: visible;
  clip-path: var(--clip-path-ds-none);
  white-space: normal;
}
